import React from 'react';
import PropTypes from 'prop-types';

/**
 * ReadinessHtmlBlocks
 *
 * Renders server-resolved readiness assessment copy authored as HTML in
 * config/locales/en.yml (RJ's "Why it matters" interstitials, the closing
 * `thank_you` message, and the "all resources" panel).
 *
 * That copy is repo-controlled content at the same trust level as the app's own
 * markup — never user input — so it renders directly, matching how Succession
 * already renders server-authored HTML (e.g. DealNdaSignReceiver's legal_text).
 *
 * Extracted from ReadinessAssessmentFlow so the LaunchPad score card can render
 * the same copy without a second raw-HTML path to audit.
 */
// `textClassName` is a prop rather than something callers append via className,
// because both would be single-class selectors and which one won would come down
// to stylesheet order rather than intent.
const ReadinessHtmlBlocks = ({ blocks, className, textClassName }) => (
  <div className={`space-y-3 ${className}`}>
    {(blocks || []).filter(Boolean).map((html, i) => (
      <div
        // eslint-disable-next-line react/no-array-index-key
        key={i}
        className={`${textClassName} [&_p]:mb-2 [&_p:last-child]:mb-0 [&_a]:text-succession-primary [&_a]:underline [&_ul]:list-disc [&_ul]:ml-5 [&_li]:mb-1`}
        dangerouslySetInnerHTML={{ __html: html }}
      />
    ))}
  </div>
);

ReadinessHtmlBlocks.propTypes = {
  blocks: PropTypes.arrayOf(PropTypes.string),
  className: PropTypes.string,
  textClassName: PropTypes.string,
};

ReadinessHtmlBlocks.defaultProps = {
  blocks: [],
  className: '',
  textClassName: 'text-sm text-succession-text-secondary leading-relaxed',
};

export default ReadinessHtmlBlocks;
